module.exports = __webpack_public_path__ + "static/media/gif-icon.163a8381.svg";